import type { ReactNode } from 'react'
import React from 'react'

import {
  Box,
  Text,
  Color,
  FontWeight,
  BorderStyle,
  Icon,
  Display,
  IconVariant,
  FlexDirection,
  AlignItems,
  JustifyContent,
} from '@gousto-internal/citrus-react'

type MenuAlertProps = {
  title: string
  children: ReactNode
}

export const MenuAlert = ({ title, children }: MenuAlertProps) => (
  <Box display={Display.Flex} justifyContent={JustifyContent.Center}>
    <Box
      bg={Color.Warning_50}
      borderColor={Color.Warning_900}
      borderWidth={0.5}
      borderStyle={BorderStyle.Solid}
      maxWidth="1540px"
      paddingH={4}
      paddingV={4}
      width="100%"
    >
      <Box display={Display.Flex} gap={2}>
        <Box color={Color.Warning_900}>
          <Icon name="warning" variant={IconVariant.Inherit} />
        </Box>

        <Box
          display={Display.Flex}
          flexDirection={FlexDirection.Column}
          gap={2}
          alignItems={AlignItems.FlexStart}
        >
          <Text color={Color.Warning_900} fontWeight={FontWeight.Bold}>
            {title}
          </Text>

          <Text>{children}</Text>
        </Box>
      </Box>
    </Box>
  </Box>
)
